module.exports = __webpack_public_path__ + "static/assets/841aaa36f1290c90d8706220b508c260.svg";